module.exports = __webpack_public_path__ + "img/ring_r_skip_1_null@3x.dd2d0acd.png";